import { RedoIncrementDecrement } from "@redotech/redo-web/arbiter-components/increment-decrement/redo-increment-decrement";
import { memo } from "react";

export const SingleNumberStepInput = memo(function SingleNumberStepInput({
  money,
  stepInteger,
  setValue,
  value,
}: {
  money: boolean;
  stepInteger: boolean;
  setValue: (value: number) => void;
  value: number | undefined;
}) {
  return (
    <RedoIncrementDecrement
      min={0}
      placeholder="0"
      prefix={money ? "$" : undefined}
      selectOnFocus
      setValue={setValue}
      size="small"
      step={stepInteger ? 1 : "any"}
      value={value}
    />
  );
});
